module.exports = __webpack_public_path__ + "assets/vue.1ce611de.svg";